<template>
	<div id="item3">
		<div id="DataContent">
			<ul id="dataMenu">
				<li>
					<router-link tag="a" to="/setting" exact>
						<Icon type="md-apps" style="margin-right: 15px;" size="25"/> 航线管理
					</router-link>
				</li>
				<li>
					<router-link tag="a" to="/setting/kepu">
						<Icon type="ios-book" style="margin-right: 15px;" size="25"/> 防御科普
					</router-link>
				</li>
                <li>
					<router-link tag="a" to="/setting/focastData">
						<Icon type="ios-aperture" style="margin-right: 15px;" size="25"/> 台风管理
					</router-link>
				</li>
        <li>
					<router-link tag="a" to="/setting/errorAnalysis">
						<Icon type="md-git-compare"  style="margin-right: 15px;" size="25"/> 误差分析
					</router-link>
				</li>
        <li>
					<router-link tag="a" to="/setting/statistics">
						<Icon type="md-stats"  style="margin-right: 15px;" size="25"/> 统计分析
					</router-link>
				</li>
        <li>
					<router-link tag="a" to="/setting/teamIntro">
						<Icon type="ios-contacts"  style="margin-right: 15px;" size="25"/> 团队介绍
					</router-link>
				</li>
			</ul>
		</div>
		<div id="DataContent-body">
			<transition enter-active-class="animated lightSpeedIn">
				<router-view></router-view>
			</transition>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      Mondata: [],
      tableData: []
    };
  },
  mounted() {

  },
  destroyed() {
  },
  methods: {

  }
};
</script>

<style>
#item3 {
  width: 100%;
  height: 100%;
}
#DataContent {
  width: 180px;
  height: 100%;
  float: left;
  background: rgb(48, 54, 67);
}
ul li {
  list-style: none;
  padding: 0;
  margin: 0;
}
#dataMenu li {
  width: 180px;
  display: grid;
  line-height: 60px;
}
#dataMenu li a {
  font-size: 16px;
  color: #fff;
  text-decoration: none;
}
#dataMenu li a:hover {
  background: #2d8cf0;
}
#dataMenu .is-active {
  background: #2d8cf0;
}
#DataContent-body {
  float: right;
  width: calc(100% - 180px);
  height: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/setting.vue